import type { MouseEvent, ReactNode } from 'react';
import { Button } from '../../atoms/Button';
import { Group } from '../../atoms/Group';

export interface RowActionsProps {
  onEdit?: (e: MouseEvent) => void;
  onDelete?: (e: MouseEvent) => void;
  editLabel?: string;
  deleteLabel?: string;
  /** Extra trailing controls (e.g. View). */
  children?: ReactNode;
  disabled?: boolean;
}

/**
 * Compact Edit / Delete controls for table action columns.
 * Always stops propagation so parent row clicks are not triggered.
 */
export function RowActions({
  onEdit,
  onDelete,
  editLabel = 'Edit',
  deleteLabel = 'Delete',
  children,
  disabled,
}: RowActionsProps) {
  return (
    <Group
      gap={6}
      wrap="nowrap"
      justify="flex-end"
      onClick={(e) => e.stopPropagation()}
    >
      {onEdit ? (
        <Button
          size="xs"
          variant="light"
          disabled={disabled}
          onClick={(e) => {
            e.stopPropagation();
            onEdit(e);
          }}
        >
          {editLabel}
        </Button>
      ) : null}
      {onDelete ? (
        <Button
          size="xs"
          color="red"
          variant="light"
          disabled={disabled}
          onClick={(e) => {
            e.stopPropagation();
            onDelete(e);
          }}
        >
          {deleteLabel}
        </Button>
      ) : null}
      {children}
    </Group>
  );
}
